import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";

declare var ko: any;


export class affiliateRevenueReport_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected affiliateFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;

    readonly viewModes = [
        { "id": "brands", "name": "Brands"},
        { "id": "affiliatePartners", "name": "Affiliate Partners"}
    ];

    readonly revenueOptions = [
        { "id": "total_rev", "name": "Total Revenue"},
        { "id": "rpm_count", "name": "RPM Contribution"},
        { "id": "rev_percentage", "name": "Revenue %"},
    ];

    protected getTemplateHtml(): string{

        return  `
            <div class="sub-header w-justify">
                
                ` + this.presetFilter.getHtmlBuild() + `

                <div class="w-left">
                    <div class="dropdown select-single">
                        <label class="form-label" for="">View Mode</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: viewModes">
                                    <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                </div>
                            </div>
                            
                        </div>
                     </div>
                     
                     <div class="dropdown select-single">
                        <label class="form-label" for="">Revenue Options</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: revenueOptionSelectedText"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">                        
                                <div class="form-group" data-bind="foreach: revenueOptions">
                                    <input type="radio" data-bind="checked : $parent.revenueOptionSelected, value: id,  attr: { 'id': 'revenue_' + id, 'name' : 'revenue_' + id }, event:{ change: $parent.onRevenueOptionChange}">
                                    <label class="form-label" data-bind="attr: {for : 'revenue_' + id }, text: name"></label>
                                </div>
                            </div>
                            
                        </div>
                     </div>
                     
                    ` + this.brandsFilter.getHtmlBuild() + ` 
                    ` + this.affiliateFilter.getHtmlBuild() + ` 
                    ` + this.datesFilter.getHtmlBuild() + ` 
                </div>
               
                 
            </div>
            
            ` + this.validationsList.getHtmlBuild()  + `
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-brands"></div>
                   <div id="selected-affiliates"></div>
                   <div id="selected-trackingId"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-affiliation">Affiliate Revenue Report</h2>
                </div>
            </div>
            
           
            
            <div id="list-results" style="position: relative">
                <div class="w-sticky-col" >
                    <table class="list-results list-sections" >
                        <thead>
                            <!-- ko foreach: headers -->
                                <tr class="list-header-section">
                                <!-- ko foreach: $data -->
                                    <th data-bind="attr: { colspan: ($parentContext.$index() !== $parentContext.$parents[0].headers().length - 1) ? $data.cols : 1 , 'class': $data.class || ''}">
                                        <span data-bind="text: label, css: $data.spanClass"></span>
                                    </th>
                                <!-- /ko -->
                                 </tr>
                            <!-- /ko -->
                        </thead>
                        <tbody>
                            <!-- ko foreach: tableData -->
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                    <!-- ko with: $parents[0].headers()[$parents[0].headers().length - 1] -->
                                        <!-- ko foreach: $data -->
                                            <td data-bind="attr: {'class': $data.columnClass || ''}, css: {'stick-col' : $index() === 0}"><span data-bind="text: $parents[1][$data.key]"></span></td>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                </tr>
                            <!-- /ko -->
                        </tbody>
                    </table>
                </div>
            </div>
            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('affiliateRevenueReport');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLogoEnabled(true);

        this.affiliateFilter = new multipleSelector_template("affiliateFilter", this.getTemplateViewModel(), this.caller);
        this.affiliateFilter.setLabel("Affiliate Partners");
        this.affiliateFilter.setFilterContainerClass('margin-neg');
        this.affiliateFilter.setTagContainerId('selected-affiliates');
        this.affiliateFilter.setTagContainerCaption('Selected Affiliate Partners:');

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{
            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

    }

    protected getTemplateName(): string{
        return "affiliateRevenueReport_template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            headers                     : ko.observableArray([])
            ,tableData                  : ko.observableArray([])
            ,viewModes                  : ko.observableArray([])
            ,viewModeSelected           : ko.observable("brands")
            ,viewModeSelectedText       : ko.observable("Brands")
            ,revenueOptions             : ko.observableArray([])
            ,revenueOptionSelected      : ko.observable("total_rev")
            ,revenueOptionSelectedText  : ko.observable("Total Revenue")
            ,selectedRows               : ko.observableArray([])
            ,onViewModeChange           : function(data){ huit_neuf_this.onViewModeChange(data); }
            ,onRevenueOptionChange      : function(data){ huit_neuf_this.onRevenueOptionChange(data); }
            ,onClickRowClick            : function(index, data){ huit_neuf_this.onClickRowClick(index); return true; }
        };
    }

    public getViewModelForRequest(){

        return {
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            affiliates: this.getTemplateViewModel().affiliateFilter.selectedItems(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            revenueOption: this.getTemplateViewModel().revenueOptionSelected(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);
        return container;
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){

        this.datesFilter.buildCalendar();
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){

            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setAffiliateFilterItems(items){

        let affiliates = [];

        for ( let item of items){

            let affiliate = {"id" : item.advertiser, "name" : item.advertiser};
            affiliates.push(affiliate);
        }

        this.affiliateFilter.setItems(affiliates);
    }

    public setViewModesItems(){

        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    private onViewModeChange(selectedViewMode){

        this.getTemplateViewModel().viewModeSelectedText(selectedViewMode.name);
        this.caller.getListData();
    }

    public setRevenueOptionsItems(){

        this.getTemplateViewModel().revenueOptions(this.revenueOptions);
    }

    private onRevenueOptionChange(selectedRevenueOption){

        this.getTemplateViewModel().revenueOptionSelectedText(selectedRevenueOption.name);
        this.caller.getListData();
    }

    public setHeader(data){

        this.getTemplateViewModel().headers(data);
        console.log(this.getTemplateViewModel().headers());
    }

    public setTableData(data){

        this.getTemplateViewModel().tableData(data);
    }


    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.affiliateFilter, params['affiliates']);

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        if(typeof params['revenueOption'] !== 'undefined'){

            this.getTemplateViewModel().revenueOptionSelected(params['revenueOption']);
            this.getTemplateViewModel().revenueOptionSelectedText(this.presetFilter.getFilterTextFromId(this.revenueOptions, params['revenueOption']));
        }

        if(typeof params['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
            this.getTemplateViewModel().viewModeSelectedText(this.presetFilter.getFilterTextFromId(this.viewModes, params['viewMode']));
        }
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/affiliateRevenueReport_template.ts